import Glide from '@glidejs/glide';

class team {
	constructor() {
		this.glide = null;
	}
	modal(el) {
		const triggers = Array.from(el.querySelectorAll('[data-modal]'));
		triggers.forEach(trigger => {
			const slide = parseInt(trigger.getAttribute('data-index'));
			const modal = document.querySelector('#' + trigger.getAttribute('data-modal'))
			trigger.addEventListener('click', (click) => {
				$(modal).on('shown.bs.modal', (e) => {
					$(modal).off('shown.bs.modal');
					this.glide = new Glide(
						modal.querySelector('.glide'), {
							startAt: slide,
							animationDuration: 0,
						}
					);
					this.glide.mount();
					Array.from(modal.querySelectorAll('.arrow')).forEach(arrow => {
						arrow.addEventListener('click', () => {
							this.glide.go(arrow.getAttribute('data-dir'));
						});
					});
				});
				$(modal).on('hidden.bs.modal', () => {
					$(modal).off('hidden.bs.modal');
					if (this.glide) {
						this.glide.destroy();
						this.glide = null;
					}
				});
				$(modal).modal();
			});
		});
	}
}

window.app.add('team', new team());